"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyleWrapper = exports.StyleMenu = exports.StyleContainerGroup = exports.StyleContainer = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _responsive = _interopRequireDefault(require("webmotors-react-pj/tokens/responsive"));
const StyleWrapper = exports.StyleWrapper = _styledComponents.default.div.withConfig({
  displayName: "StyleWrapper",
  componentId: "sc-pyyuk9-0"
})(["flex:1;display:flex;justify-content:space-between;align-items:center;padding:0 16px;min-height:56px;@media ", "{height:56px;padding:0 32px;}"], _responsive.default.lg);
const StyleContainer = exports.StyleContainer = _styledComponents.default.div.withConfig({
  displayName: "StyleContainer",
  componentId: "sc-pyyuk9-1"
})(["display:none;@media ", "{display:flex;}"], _responsive.default.lg);
const StyleContainerGroup = exports.StyleContainerGroup = _styledComponents.default.div.withConfig({
  displayName: "StyleContainerGroup",
  componentId: "sc-pyyuk9-2"
})(["display:flex;align-items:left;padding:0px 16px 8px;width:100%;@media ", "{display:none;}"], _responsive.default.lg);
const StyleMenu = exports.StyleMenu = _styledComponents.default.div.withConfig({
  displayName: "StyleMenu",
  componentId: "sc-pyyuk9-3"
})(["display:flex;align-items:center;"]);